import { css, StyleSheet } from 'aphrodite';
import { ReactNode } from 'react';
import { Button } from '../../../../../../components-v2/Button';
import { Popover, PopoverAnchor, PopoverArrow, PopoverContent } from '../../../../../../components-v2/Popover';
import { THEME } from '../../../../../../components-v2/Theme/theme';

interface DeleteConfirmationPopoverProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
	message: ReactNode;
	/** The element the popover anchors to — NOT the popover's content (that's built from `message`). */
	children: ReactNode;
	confirmDisabled?: boolean;
}

const styles = StyleSheet.create({
	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		maxWidth: 280,
	},
	message: {
		margin: 0,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		overflowWrap: 'break-word',
	},
	confirmButton: {
		alignSelf: 'flex-start',
	},
});

export const DeleteConfirmationPopover = ({
	open,
	onOpenChange,
	onConfirm,
	message,
	children,
	confirmDisabled,
}: DeleteConfirmationPopoverProps) => (
	<Popover open={open} onOpenChange={onOpenChange}>
		<PopoverAnchor asChild>{children}</PopoverAnchor>
		<PopoverContent side='top' align='end' styles={[styles.content]}>
			<PopoverArrow />
			<p className={css(styles.message)}>{message}</p>
			<Button
				variant='destructive'
				size='sm'
				styles={[styles.confirmButton]}
				onClick={() => {
					onConfirm();
					onOpenChange(false);
				}}
				disabled={confirmDisabled}
			>
				Delete
			</Button>
		</PopoverContent>
	</Popover>
);
